import {Popover} from 'bootstrap';
import {ComponentContext} from '../../IComponent';

export default class CitationPreview {
    private readonly cleanups: (() => void)[] = [];
    private readonly translationRoots: JQuery<HTMLElement>;

    constructor(root: HTMLElement, private readonly context?: ComponentContext) {
        this.translationRoots = $(root).find<HTMLElement>('[data-content-translation]');
        this.context?.components?.mount(this.translationRoots);

        root.querySelectorAll<HTMLElement>('[data-bs-toggle="popover"]').forEach(badge => {
            if (
                !badge.querySelector('[data-content-translation]')
                && !(badge.getAttribute('data-bs-content') || '').includes('data-content-translation')
            ) {
                return;
            }

            const allowList = {
                ...Popover.Default.allowList,
                span: [
                    ...(Popover.Default.allowList.span || []),
                    'data-component', 'data-content-translation', 'data-options',
                    'data-translation-field', 'data-translation-render', 'data-translation-truncate',
                    'data-translation-strip-html',
                ],
                template: ['data-translation-original'],
            };
            const popover = Popover.getOrCreateInstance(badge, {allowList});
            $(badge).data('popover-initialized', true);
            let body: HTMLElement | null = null;
            let bodyRoots: JQuery<HTMLElement> | null = null;
            const update = () => popover.update();
            const unmountBody = () => {
                if (body) {
                    body.removeEventListener('content-translation-state-changed', update);
                    this.context?.components?.unmount(bodyRoots);
                    body = null;
                    bodyRoots = null;
                }
            };
            const show = () => {
                unmountBody();
                root.querySelectorAll<HTMLElement>('[data-bs-toggle="popover"]').forEach(other => {
                    if (other !== badge) {
                        Popover.getInstance(other)?.hide();
                    }
                });
            };
            const shown = () => {
                const tip = document.getElementById(badge.getAttribute('aria-describedby'));
                if (!tip?.classList.contains('show') || body) {
                    return;
                }
                body = tip.querySelector<HTMLElement>('.popover-body');
                if (body) {
                    bodyRoots = $(body).find<HTMLElement>('[data-content-translation]');
                    body.addEventListener('content-translation-state-changed', update);
                    this.context?.components?.mount(bodyRoots);
                }
            };
            badge.addEventListener('show.bs.popover', show);
            badge.addEventListener('shown.bs.popover', shown);
            badge.addEventListener('hide.bs.popover', unmountBody);
            this.cleanups.push(() => {
                unmountBody();
                badge.removeEventListener('show.bs.popover', show);
                badge.removeEventListener('shown.bs.popover', shown);
                badge.removeEventListener('hide.bs.popover', unmountBody);
                popover.dispose();
                $(badge).removeData('popover-initialized');
            });
        });
    }

    public destroy(): void {
        this.cleanups.forEach(cleanup => cleanup());
        this.context?.components?.unmount(this.translationRoots);
    }
}
